import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useL10n } from '@uplift/hooks';
import { ROUTING_CONFIG } from '@uplift/constants';
import { Button } from '@uplift/ui-v2';
import { observer } from 'mobx-react-lite';
import { ConnectionTips } from '../modals';

import { useHangUpStyles } from './hung-up.styles';
import { Appointment, CurrentUser } from '@uplift/api';

export type HungUpPageType = {
  me: CurrentUser;
  appointment: Appointment;
  isRoomClosed: boolean;
  reEnterCall: () => void;
};

export const HungUpPage: React.FC<HungUpPageType> = observer(({ isRoomClosed, reEnterCall }) => {
  const { push } = useHistory();
  const l10n = useL10n();
  const { classes } = useHangUpStyles();

  return (
    <Box className={classes.container}>
      <Typography variant="h3">
        {isRoomClosed ? l10n.sessions.done : l10n.sessions.leftTheSession}
      </Typography>

      <Box mt={5} className={clsx(classes.buttonSection, { [classes.fullWidth]: !isRoomClosed })}>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => push(ROUTING_CONFIG.dashboard)}
          fullWidth
        >
          {l10n.sessions.returnHome}
        </Button>

        {!isRoomClosed && (
          <Button
            disabled={isRoomClosed}
            color="secondary"
            variant="outlined"
            onClick={reEnterCall}
            fullWidth
          >
            {l10n.sessions.rejoinSession}
          </Button>
        )}
        <ConnectionTips />
      </Box>
    </Box>
  );
});
